__webpack_require__.p = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/";